import React from 'react';
import RouteThumbnailsFullTree from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsFullTree';

export default function RouteThumbnailsFullTreeContainer({ tree, routeName, treeTooltip, updateTreeThumbnailDetails }) {
  return (
    <RouteThumbnailsFullTree
      tree={tree}
      routeName={routeName}
      onTreeNodeClick={(target, data) => {
        if (treeTooltip && treeTooltip.data && treeTooltip.data.id === data.id) {
          updateTreeThumbnailDetails();
        } else {
          updateTreeThumbnailDetails(target, data);
        }
      }}
    />
  );
}
